import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const IconSwitch = styled(Switch)(({ theme }) => ({
	width: 60,
	height: 40,
	padding: 10,
	"& .MuiSwitch-switchBase": {
		padding: 8,
		"&.Mui-checked": {
			transform: "translateX(20px)",
			color: "#fff",
			"& + .MuiSwitch-track": {
				backgroundColor: theme.palette.primary.main,
				opacity: 1,
			},
		},
	},
	"& .MuiSwitch-thumb": {
		width: 20, // ← Bigger thumb
		height: 20,
		backgroundColor: theme.palette.secondary.main,
		position: "relative",
		"&::before": {
			content: '"🎲"', // or use an icon/image
			position: "absolute",
			top: "55%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			fontSize: "28px",
		},
	},
	"& .MuiSwitch-track": {
		borderRadius: 20,
		backgroundColor: theme.palette.grey[400],
		opacity: 1,
	},
}));
export default IconSwitch;
